import { buildCmsUrl, CMSApiBase } from './base';
import { request } from '@/api/base';
import { snakify } from '@/helpers/common';

export interface ThirdPartySummaryCommon {
  userId: number;
  modalId: string;
}

export type ThirdPartySummary = ThirdPartySummaryCommon & CMSApiBase;

export const pushThirdPartySummaries = (summary: ThirdPartySummaryCommon) =>
  request<ThirdPartySummary>({
    method: 'POST',
    url: buildCmsUrl({ path: 'third-party-summaries' }),
    data: snakify(summary),
  });
